<template>
  <div class="form-row">
    <div class="col-12 col-md-6">
          <div class="name">
            {{ questionNumber }}. {{ question.QuestionText }}
          </div>
          <div class="response">
            {{ this.questionResponse }}
          </div>
    </div>
    <div class="col-12 col-md-6">
      <a role="button" class="show-link float-md-right"
        v-if="question.AdviceResources.length !== 0"
        @click="showAdviceResources = !showAdviceResources"
        @keydown.enter="showAdviceResources = !showAdviceResources"
        tabindex="0"
      >
        Show advice<span :class="showAdviceResources?'angle-up-green':'angle-down-green'"></span>
      </a>
    </div>
    <div class="col-md-12 mt-3">
      <div
        class="html-content advice"
        v-show="showAdviceResources"
        v-html="question.AdviceResources"
      ></div>
    </div>
    <div v-if="question.SAT_SavedResponses.Comment && question.SAT_SavedResponses.Comment.length > 0 && question.SAT_SavedResponses.Comment.trim() !== ''" class="col-md-12 mt-3">
      <div class="response">
        Comments
      </div>
      <div class="body">
        {{ question.SAT_SavedResponses.Comment }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActionPlanQuestion",
  data() {
    return {
      showAdviceResources: false,
      showComment: false,
      questionResponse: ""
    };
  },
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    questionNumber: {
      type: Number,
      default: () => 0
    }
  },
  created() {
    this.questionResponse = this.question.SAT_SavedResponses.PositiveResponse
      ? this.question.PositiveResponse
      : this.question.SAT_SavedResponses.PartialResponse
      ? this.question.PartialResponse
      : this.question.SAT_SavedResponses.NotApplicable
      ? this.question.NotApplicable
      : this.question.SAT_SavedResponses.NegativeResponse
      ? this.question.NegativeResponse
      : "";
  }
};
</script>

<style lang="sass" scoped></style>
